import React from "react";
import "./FacialServiceCard.css";
import "../../MainServicePages/ServiceCards/ServiceCards.css";
import ServiceCards from "../../MainServicePages/ServiceCards/ServiceCards";
const FacialServiceCardContain = () => {
  return (
    <div className="serviceCardContainer">
      <ServiceCards
        heading="Organic Cleanup Facial"
        para="Encapsulated with kakadu plum,noni fruit& dead sea minerals,this facial clarifies and cleanses the skin"
        goto="Organic Cleanup Facial"
        img="https://img.freepik.com/free-photo/woman-with-mask-cucumber-her-eyes_1303-16792.jpg?t=st=1714634299~exp=1714637899~hmac=22b38394039b15e50839b39ee7696af58182f53e65be101b9a390e23190254fc&w=900"
        link="/organic-facial-services"
      />
      <ServiceCards
        heading="Snow white facial"
        para="For brighter and radiant skin canadian willow herb/papain enzymes/cucumber herbal extracts "
        goto="Snow White Facial"
        img="https://cdn.pixabay.com/photo/2023/08/31/08/58/facial-8224799_640.jpg"
        link="/snow-white-facial-services"
      />
      <ServiceCards
        heading="Dead Sea Mineral Facial"
        para="With pure minerals from dead sea works on hydration and tightening of skin"
        goto="Dead Sea Mineral Facial"
        img="https://img.freepik.com/free-photo/top-view-smiley-woman-with-face-mask_23-2148520307.jpg?t=st=1714634503~exp=1714638103~hmac=619e121da9e538bf0b71cc302e09450503e4dc3a58a45ca73124ea275c72cab7&w=900"
        link="/dead-sea-mineral-facial-services"
      />
      <ServiceCards
        heading="Chocolate Mint Facial"
        para="This magical Combination of coffee,mint,korean cica,seabuckthorn enchances & lightens skin while fighting lack of elasticity"
        goto="Chocolate Mint Facial"
        img="https://img.freepik.com/free-photo/spa-massage-young-woman-with-facial-mask-face-indoors_186202-7632.jpg?t=st=1714712908~exp=1714716508~hmac=353c858031eeab28d19ad3a1dfc5f3e9c5d2619b9e020aca831ed4b48e6fe874&w=826"
        link="/chocolate-mint-facial-services"
      />
      <ServiceCards
        heading="White Secret"
        para="For intense radiance and glow highly active plant extract/echium seed oil/liquorice root extracts"
        goto="White Secret"
        img="https://img.freepik.com/free-photo/beautician-with-brush-applies-white-moisturizing-mask-face-young-girl-client-spa-beauty-salon_343596-4248.jpg?t=st=1714712995~exp=1714716595~hmac=cd58584b8e050fb7f6c83ff3e443df02ffa41c90b19b989bfe448d737c442a36&w=360"
        link="/white-secret-facial-services"
      />
      <ServiceCards
        heading="Acne Cure Facial"
        para="For reducing acne pimples & pigmentation"
        goto="Acne Cure Facial"
        img="https://img.freepik.com/free-photo/woman-beauty-salon-face-treatment_23-2148875519.jpg?t=st=1714713085~exp=1714716685~hmac=984f3331c665acd6d390bddb12fb6613f90fc8ab4c75f6c823d89b90c9c81074&w=826"
        link="/acne-cure-facial-services"
      />
      <ServiceCards
        heading="Diamond Glow Facial"
        para="For instant brightening glow and hydration"
        goto="Diamond Glow Facial"
        img="https://img.freepik.com/premium-photo/vitamina-c_782077-1256.jpg?w=360"
        link="/diamond-glow-facial-services"
      />
      <ServiceCards
        heading="Anti Ageing Facial"
        para="For tightening,pore cleansing and instant brightening "
        goto="Anti Ageing Facial"
        img="https://img.freepik.com/free-photo/clean-senior-woman-bathrobe_23-2148278034.jpg?t=st=1714713342~exp=1714716942~hmac=20d58469f2a31d7e12fb379b5989f1ab673fe028f9491fabe864472f4315b8bf&w=900"
        link="/anti-ageing-facial-services"
      />
      <ServiceCards
        heading="Gold Facial"
        para="This magnificent facial is great forrevamping dehydrated skin with morocco's pure gold argan oil, vitamin C & hyaluronic"
        goto="Gold Facial"
        img="https://img.freepik.com/premium-photo/cosmetologist-applying-gold-mask-glowing-hydrated-skin-spa_1111209-28508.jpg?w=900"
        link="/gold-facial-services"
      />
      <ServiceCards
        heading="Eye Protection Facial"
        para="Carboxytherapy-inspired cosmetic technology that treats and prevents all asethetic concerns of the eye area "
        goto="Eye Protection Facial"
        img="https://img.freepik.com/free-photo/beautiful-young-woman-face_155003-1203.jpg?t=st=1714713488~exp=1714717088~hmac=e506b3c07747cb77b2016e291e3077e5d116cc7b93e667b428ac93cd5ffc5e42&w=900"
        link="/eye-protection-facial-services"
      />
      <ServiceCards
        heading="Hydra Lifting Ocean Miracle"
        para="Firming anti-ageing marine biotechnology combined with  properties of quinton sea water"
        goto="Hydra Lifting Ocean Miracle"
        img="https://img.freepik.com/premium-photo/woman-with-blue-eyes-blue-glittery-face-is-shown_802234-30425.jpg?w=900"
        link="/hydra-lifting-ocean-miracle-facial-services"
      />
      <ServiceCards
        heading="Luminous Lightening Facial"
        para="Clarifying and lightening anti-ageing treatment ,surrounds your skin in a halo of light and youth "
        goto="Luminous Lightening Facial"
        img="https://img.freepik.com/premium-photo/led-light-antiaging-mask-facial-skin-care-spa-slow-motion-woman-lies-couch-spec_152904-15563.jpg?w=360"
        link="/luminous-lightening-facial-services"
      />
      <ServiceCards
        heading="Brazilian Skin Lightening"
        para="Treatment for intimate areas, no more darkness out there, when doing this regularly "
        goto="Brazilian Skin Lightening"
        img="https://img.freepik.com/premium-photo/harmony-twilight-facial-treatment-elation_153608-21422.jpg?w=900"
        link="/brazilian-skin-lightening-facial-services"
      />
    </div>
  );
};

export default FacialServiceCardContain;
